/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Native_Release_Strava_HintInputs */

const en_us2_native_release_strava_hint = /** @type {(inputs: Native_Release_Strava_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each finished workout becomes a weight training activity on your Strava.`)
};

const pt_br2_native_release_strava_hint = /** @type {(inputs: Native_Release_Strava_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada treino concluído vira uma atividade de musculação no seu Strava.`)
};

const pt_pt2_native_release_strava_hint = /** @type {(inputs: Native_Release_Strava_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada treino concluído vira uma atividade de musculação no seu Strava.`)
};

/** @type {(inputs: Native_Release_Strava_HintInputs) => LocalizedString} */
const es_419_native_release_strava_hint = en_us2_native_release_strava_hint;

/** @type {(inputs: Native_Release_Strava_HintInputs) => LocalizedString} */
const fr_fr2_native_release_strava_hint = en_us2_native_release_strava_hint;

/** @type {(inputs: Native_Release_Strava_HintInputs) => LocalizedString} */
const de_de2_native_release_strava_hint = en_us2_native_release_strava_hint;

/** @type {(inputs: Native_Release_Strava_HintInputs) => LocalizedString} */
const it_it2_native_release_strava_hint = en_us2_native_release_strava_hint;

/**
* | output |
* | --- |
* | "Each finished workout becomes a weight training activity on your Strava." |
*
* @param {Native_Release_Strava_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_strava_hint = /** @type {((inputs?: Native_Release_Strava_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Strava_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_strava_hint(inputs)
	if (locale === "es-419") return es_419_native_release_strava_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_strava_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_strava_hint(inputs)
	if (locale === "de-DE") return de_de2_native_release_strava_hint(inputs)
	if (locale === "it-IT") return it_it2_native_release_strava_hint(inputs)
	return en_us2_native_release_strava_hint(inputs)
});
export { native_release_strava_hint as "native-release.strava_hint" }